import Enum from "./Enum";

const EnumTimeZone = new Enum({
    GST: {name: "GST (UAE)", offset: "+4", zone: "Asia/Dubai"},
    AST: {name: "AST (Kuwait)", offset: "+3", zone: "Asia/Kuwait"}
});

export default EnumTimeZone;